var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manipulableimage"},[_c('div',{ref:"manipulableImage",staticClass:"manipulable",style:(_vm.manipulableStyles)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }